<template>
  <component :is="tag" role="row" class="row" :class="{
      'row--center': center
    }">
    <slot />
  </component>
</template>

<script>
// @flow
export default {
  name: "SmartRow",
  props: {
    tag: {
      type: String,
      default: "section"
    },
    center: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
section {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
</style>